import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型
import { SettleOrderDetail } from '../../service/class/SettleOrder';

// 借助 createSlice 创建 reducer、action
const SettleOrderDetailSlice = createSlice({
    name: 'settleOrderDetail',
    initialState: {
        value: new SettleOrderDetail(),
    },
    reducers: {
        setSettleOrderDetail: (state, action: PayloadAction<SettleOrderDetail>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setSettleOrderDetail } = SettleOrderDetailSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const settleOrderDetailSelector = (state: RootState) => state.settleOrderDetail.value;

// Reducer，真正执行修改 state 的纯函数
export default SettleOrderDetailSlice.reducer;
